import { render, staticRenderFns } from "./AdminViewInfo.vue?vue&type=template&id=7ba8b7a4&"
import script from "./AdminViewInfo.vue?vue&type=script&lang=ts&"
export * from "./AdminViewInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports